import type { FC } from 'react';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { useCypressData } from 'Utilities/hooks/useCypressData';

import LocalTexts from './EmptyAndErrorView.texts';

import styles from './EmptyAndErrorView.module.scss';

const LocalT = new MDText(LocalTexts);

export enum View {
	EMPTY = 'EMPTY',
	ERROR = 'ERROR',
}

interface EmptyAndErrorViewProps {
	handleOnClick: () => void;
	view: View;
}

const EmptyAndErrorView: FC<EmptyAndErrorViewProps> = ({ handleOnClick, view }) => {
	const viewKey = view.toLocaleLowerCase();

	const [cypressIds, applyCypressData] = useCypressData();

	return (
		<div className={styles.container}>
			<h3>{LocalT.translate('heading1')}</h3>
			<p>{LocalT.translate(`${viewKey}.body`)}</p>
			<Button
				{...applyCypressData(cypressIds.buttons.insights.emptyAndErrorView.cta)}
				label={LocalT.translate(`${viewKey}.buttonText`)}
				onClick={handleOnClick}
			/>
		</div>
	);
};

export default EmptyAndErrorView;
